import { render, staticRenderFns } from "./OrdersMap.vue?vue&type=template&id=49ef0382"
import script from "./OrdersMap.vue?vue&type=script&lang=js"
export * from "./OrdersMap.vue?vue&type=script&lang=js"
import style0 from "./OrdersMap.vue?vue&type=style&index=0&id=49ef0382&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports